var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserService } from '@modules/Users/services/UserService';
import { UserFormBuilder } from '@modules/Users/services/UserFormBuilder';
var UserEditFormActionsComponent = /** @class */ (function () {
    function UserEditFormActionsComponent(service, formBuilder) {
        this.service = service;
        this.formBuilder = formBuilder;
        this.error = null;
        this.submitting = false;
        this.isSendResetPasswordEnabled = false;
        this.isSetPasswordEnabled = false;
    }
    UserEditFormActionsComponent.prototype.ngOnInit = function () {
    };
    UserEditFormActionsComponent.prototype.resetPassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = this.formBuilder.map(this.formUser, this.user);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.isSendResetPasswordEnabled = true;
                        this.submitting = true;
                        return [4 /*yield*/, this.service.resetPassword(user)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        this.error = error_1;
                        return [3 /*break*/, 5];
                    case 4:
                        this.isSendResetPasswordEnabled = false;
                        this.submitting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    UserEditFormActionsComponent.prototype.setPassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (!this.password || (this.password && this.password.length < 8)) {
                            return [2 /*return*/];
                        }
                        user = this.formBuilder.map(this.formUser, this.user);
                        this.isSetPasswordEnabled = true;
                        this.submitting = true;
                        return [4 /*yield*/, this.service.setUserPassword(this.password, user)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        this.error = error_2;
                        return [3 /*break*/, 4];
                    case 3:
                        this.isSetPasswordEnabled = false;
                        this.submitting = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserEditFormActionsComponent.prototype.isValid = function (date) {
        return (date !== '0001-01-01T00:00:00') && (date !== '0001-01-01T00:00:00+00:00');
    };
    return UserEditFormActionsComponent;
}());
export { UserEditFormActionsComponent };
